import { loader } from 'graphql.macro';

export const ADD_BOOKMARK = loader('./addBookmarkMutation.graphql');
export const CREATE_NOTIFICATION = loader(
  './createNotificationMutation.graphql',
);
export const CREATE_WITHDRAWAL_TRANSACTION = loader(
  './withdrawalTransactionMutation.graphql',
);
export const DELETE_BOOKMARK = loader('./deleteBookmarkMutation.graphql');
export const DELETE_NOTIFICATION = loader(
  './deleteNotificationMutation.graphql',
);
export const DEPOSIT_PLAN_MUTATION = loader('./depositPlanMutation.graphql');
export const ELEVATE_TOKENS_MUTATION = loader(
  './elevateTokensMutation.graphql',
);
export const INVITE_BY_EMAILS = loader('./inviteByEmailsMutation.graphql');
export const INTERNAL_TRX_SUBMIT = loader(
  './internalTransactionSubmitMutation.graphql',
);
export const LOAN_PLAN_MUTATION = loader('./loanPlanMutation.graphql');
export const MARK_ANNOUNCEMENTS_READ = loader(
  './markAnnouncementsReadMutation.graphql',
);
export const SET_PERSONAL_REWARD_TRANSFER = loader(
  './setPersonalRewardPlatformTransfer.graphql',
);
export const SET_DEPOSIT_ALLOW_EQUAL_PCT_OFFSET = loader(
  './setDepositAllowEqualPctOffsetMutation.graphql',
);
export const SET_NAVIGATION_VISIBILITY = loader(
  './setNavigationVisibilityMutation.graphql',
);
export const UPDATE_AGENT_AGREEMENT_POPUP_MUTATION = loader(
  './updateAgentAgreementPopUpMutation.graphql',
);
export const UPDATE_DRAFT = loader('./updateDraftMutation.graphql');
export const UPDATE_LOCALE = loader('./changeLocaleMutation.graphql');
export const UPDATE_THEME = loader('./changeThemeMutation.graphql');
export const UPDATE_TO_AGENT_ROLE_MUTATION = loader(
  './updateToAgentRoleMutation.graphql',
);
export const UPDATE_VIEWER = loader('./viewerMutation.graphql');
